// extracted by mini-css-extract-plugin
export default {"dnb_login_button":"LoginButton-module--dnb_login_button--5b4fd"};